import Axios from 'axios';

import { GEOCODING_KEY } from '../../constants/maps';
import { Location } from '../../types';

export class MapUtils {
  geocodeLocation(location: Location) {
    let searchText: string;
    if (location.level == 'Area') {
      searchText = `${location.area}, ${location.city}`;
    } else {
      searchText = location.label;
    }
    searchText += ', Philippines';

    let promise = Axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: {
          address: searchText,
          key: GEOCODING_KEY
        }
      }
    );

    return promise;
  }
}
